import types from '../types';
import superagent from '@ott/superagent';

// ?fromCountryId=metaFromCountryId&toCountryId=metaToCountryId

export function checkRoundTrip(from, to) {
  return {
    promise: async () => {
      try {
        // eslint-disable-next-line vars-on-top, no-var
        var { body } = await superagent
          .get('/_railways/rzd/roundtrip')
          .query({
            fromCountryId: from,
            toCountryId: to,
          })
          .withCredentials();
        // eslint-disable-next-line no-empty
      } catch (e) {}

      // eslint-disable-next-line block-scoped-var
      if (!body || body.error) {
        // eslint-disable-next-line block-scoped-var
        return Promise.reject((body && body.error) || {});
      }

      // eslint-disable-next-line block-scoped-var
      return body;
    },
    types: [types.ROUNDTRIP_CHECK, types.ROUNDTRIP_CHECK_SUCCESS, types.ROUNDTRIP_CHECK_FAIL],
  };
}
